class Reload {

    private timeoutHandle: any;

    constructor( ) { }

    /**
     * This timer reloads frontpage after 5 minutes
     */
     start(): void {
        this.timeoutHandle = setTimeout(() => {
            window.location.reload();
        }, 5 * 60 * 1000);
    }

    stop(): void {
        window.clearTimeout(this.timeoutHandle);
    }

}

export default Reload;